import * as React from 'react';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { InjectedIntlProps } from 'react-intl';
import { injectIntl, FormattedMessage } from 'react-intl';
import { ThemedLink } from 'view/common/themed-link';

import { Wrapper, SignupMessage } from './styled';
import messages from './messages';

interface Props {
    isError: boolean;
}

export const AnonymousEmailSignupMessage = ({ isError, intl }: Props & InjectedIntlProps) => {
    return (
        <Wrapper>
            {isError ? (
                <ErrorIcon
                    size={'small'}
                    label="error"
                    primaryColor={token('color.icon.danger', colors.R300)}
                    secondaryColor={token('color.icon.inverse', colors.N0)}
                />
            ) : (
                <WarningIcon size={'small'} label="warning" primaryColor={token('color.icon.warning', colors.Y300)} />
            )}

            <SignupMessage isError={isError}>
                <FormattedMessage
                    {...messages.signupWarningMessage}
                    values={{
                        signUpLink: (
                            <ThemedLink to={'/user/login'} target="_blank" actionSubjectId="signupLink">
                                {intl.formatMessage(messages.signupLink)}
                            </ThemedLink>
                        ),
                    }}
                />
            </SignupMessage>
        </Wrapper>
    );
};

export default injectIntl(AnonymousEmailSignupMessage);
